import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, IonFooter } from '@ionic/react'
import { UseHeader, CouponItem, CouponDetail, MktButton } from '@cps'
import { memberMobx } from '@mobxStore'
import MemberApi from 'api/member.api'
import { modalLayer, useHistoryNew, toast } from '@utils'
import { format } from '@dt/fe-utils'
import i18n from 'i18next'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const pageSize: number = 12

const CouponRecordPage: FC<IProps> = ({ match, pageName }) => {
  const history = useHistoryNew()
  const [logInfo, setLogInfo] = useState<any>(null)
  const [cashCoupon, setCashCoupon] = useState<any[]>([])
  const [orderCoupon, setOrderCoupon] = useState<any[]>([])
  const [itemCoupon, setItemCoupon] = useState<any[]>([])
  const { recordId } = match.params as any
  // Data Method

  // Componeent Event
  const goDetail = (data: any) => {
    modalLayer(CouponDetail, { type: 'use', couponInfo: data }, 'couponDetail')
  }
  const cancelGive = () => {
    MemberApi.cancelGiveCoupon({
      brandId: memberMobx.brandId,
      memberCouponGiveId: Number(recordId),
    }).then(() => {
      toast({ message: i18n.t('mkt.coupon.transferCancel'), position: 'bottom' })
      memberMobx.getMemberCoupons()
      history.goBack()
    })
  }
  // Component Effect
  useEffect(() => {
    if (recordId) {
      const para: any = {
        brandId: memberMobx.brandId,
        memberCouponGiveId: Number(recordId)
      }
      MemberApi.getCouponGiveLog(para).then((res: any) => {
        if (!res.error) {
          setLogInfo(res)
          setCashCoupon(res.coupons.filter((item: any) => item.type === 'cash'))
          setOrderCoupon(res.coupons.filter((item: any) => item.type === 'order' || item.type === 'designate' || item.type === 'ladder' || item.type === 'express'))
          setItemCoupon(res.coupons.filter((item: any) => item.type === 'item'))
        }
      })
    }
  }, [recordId])

  return (
    <IonPage className='coupon-gift-record-detail'>
      <UseHeader title={i18n.t('mkt.coupon.couponDetails')} onBack={() => history.goBack()}></UseHeader>
      <IonContent className='page-content'>
        {
          logInfo &&
            <div className='info-area'>
              <div className='title'>{i18n.t('mkt.giftCard.transferInfo')}</div>
              {
                logInfo.receiverEmail &&
                  <div className='info-item'>
                    <span>{i18n.t('mkt.giftCard.receiveMail')}</span>
                    <span className='right'>{logInfo.receiverEmail}</span>
                  </div>
              }
              {
                logInfo.receiverMobile &&
                  <div className='info-item'>
                    <span>{i18n.t('mkt.giftCard.receiveMobile')}</span>
                    <span className='right'>+{logInfo.countryCode} {logInfo.receiverMobile}</span>
                  </div>
              }
              <div className='info-item'>
                <span>{i18n.t('mkt.giftCard.donationStatus')}</span>
                <span className={`right ${logInfo.status === 'unAccept' && 'unAccept'}`}>
                  {logInfo.status === 'cancel' && i18n.t('order.cancel')}
                  {logInfo.status === 'unAccept' && i18n.t('mkt.coupon.notYetReceived')}
                  {logInfo.status === 'accept' && i18n.t('mkt.coupon.received')}
                </span>
              </div>
              <div className='info-item'>
                <span>{i18n.t('mkt.giftCard.transferTime')}</span>
                <span className='right'>{format.toDateTime(logInfo.addTime)}</span>
              </div>
              <div className='info-item'>
                <span>{i18n.t('mkt.giftCard.donationTime')}</span>
                <span className='right'>{logInfo.receiveTime ? format.toDateTime(logInfo.receiveTime) : '--'}</span>
              </div>
            </div>
        }
        <div className='coupon-body'>
          {
            logInfo && logInfo.coupons.length > 0 &&
              <>
                {
                  cashCoupon.length > 0 &&
                    <div className='coupon-areaa'>
                      <div className='area-title'>{i18n.t('mkt.coupon.cashCoupons')}</div>
                      {
                        cashCoupon.map((item: any) => {
                          return (
                            <div className='coupon-block' key={item.memberCouponId}>
                              <CouponItem type='use' couponInfo={item} onDetail={goDetail}></CouponItem>
                            </div>
                          )
                        })
                      }
                    </div>
                }
                {
                  orderCoupon.length > 0 &&
                    <div className='coupon-areaa'>
                      <div className='area-title'>{i18n.t('mkt.coupon.fullDiscountCoupons')}</div>
                      {
                        orderCoupon.map((item: any) => {
                          return (
                            <div className='coupon-block' key={item.memberCouponId}>
                              <CouponItem type='use' couponInfo={item} onDetail={goDetail}></CouponItem>
                            </div>
                          )
                        })
                      }
                    </div>
                }
                {
                  itemCoupon.length > 0 &&
                    <div className='coupon-areaa'>
                      <div className='area-title'>{i18n.t('mkt.coupon.itemCoupons')}</div>
                      {
                        itemCoupon.map((item: any) => {
                          return (
                            <div className='coupon-block' key={item.memberCouponId}>
                              <CouponItem type='use' couponInfo={item} onDetail={goDetail}></CouponItem>
                            </div>
                          )
                        })
                      }
                    </div>
                }
              </>
          }
        </div>
      </IonContent>
      {
        logInfo && logInfo.status === 'unAccept'
          ? (
            <IonFooter>
              <MktButton onClick={cancelGive}>
                <span>{i18n.t('mkt.common.unGift')}</span>
              </MktButton>
            </IonFooter>
          ) : ''
      }
    </IonPage>
  )
}

export default observer(CouponRecordPage)
